import { createListenerMiddleware } from '@reduxjs/toolkit'
import { LOCATION_CHANGE } from 'connected-react-router'
import { SET_BYPASS_REGION_FILTER } from 'actions/actionConstants'
import { getBypassRegionCookie, setBypassRegionCookieOnce } from 'cookies/bypassRegionCookie'

const bypassRegionMiddleware = createListenerMiddleware()

bypassRegionMiddleware.startListening({
  type: LOCATION_CHANGE,
  effect: (action, listenerApi) => {
    const search = (action as any).payload?.location?.search ?? ''
    const params = new URLSearchParams(search)
    const urlBypass = params.get('bypassRegionFilter') === 'true'

    if (urlBypass) {
      setBypassRegionCookieOnce()
    }

    const active = urlBypass || getBypassRegionCookie()
    const state = listenerApi.getState() as App.State

    if (active !== state.marketing.bypassRegionFilter) {
      listenerApi.dispatch({ type: SET_BYPASS_REGION_FILTER, value: active })
    }
  },
})

export default bypassRegionMiddleware
